import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[600px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=dark%20cinematic%20Chinese%20entertainment%20gossip%20background%2C%20abstract%20red%20and%20black%20geometric%20shapes%2C%20paparazzi%20flash%20lights%20effect%2C%20dramatic%20stage%20lighting%2C%20luxury%20red%20carpet%20texture%2C%20mysterious%20dark%20atmosphere%20with%20warm%20accents&width=1800&height=900&seq=hero-bg-main&orientation=landscape"
          alt="黑料吃瓜网 - 娱乐八卦热点"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center py-16 md:py-20">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-500/20 backdrop-blur-sm border border-accent-400/30 mb-6">
          <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse"></span>
          <span className="text-sm text-accent-300 font-medium">🔥 实时更新 · 最新爆料</span>
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 font-heading leading-tight mb-4">
          第一时间吃最<span className="text-primary-400">劲爆的瓜</span>
        </h1>

        <p className="text-base md:text-lg text-background-200/90 max-w-2xl mx-auto leading-relaxed mb-8">
          汇聚娱乐圈最新黑料、明星八卦、热点事件与独家爆料，每日实时更新，追踪娱乐圈内幕动态。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-10">
          <Link
            to="/category/star-gossip"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 font-semibold hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer text-sm"
          >
            <i className="ri-fire-line w-4 h-4 flex items-center justify-center"></i>
            立即吃瓜
          </Link>
          <Link
            to="/about"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-background-50/10 backdrop-blur-sm border border-background-200/30 text-background-50 font-medium hover:bg-background-50/20 transition-all duration-300 whitespace-nowrap cursor-pointer text-sm"
          >
            了解更多
          </Link>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-3">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="px-4 py-2 rounded-full bg-background-50/10 backdrop-blur-sm border border-background-200/20 text-background-100 text-sm hover:bg-primary-500/30 hover:border-primary-400/40 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              {cat.name}
            </Link>
          ))}
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}